import { useRef, FC } from "react";
import { Chart } from "chart.js";

import { saveImage } from "../../utils/utilities";
import { error } from "../../services/toastService";

import Conditional from "../common/conditional";
import css from "../themed/charts/charts.module.scss";

function withChart(Component: any): FC<any> {
  return function WithChart(props): JSX.Element {
    const chartRef = useRef<Chart>();

    const downloadImage = (): void => {
      const imageString: string | undefined = chartRef.current?.toBase64Image();
      if (!imageString) return error("Image is not currently available");

      saveImage(imageString, imageString.substring(0, 10));
    };

    return (
      <div className={css.chart}>
        <Conditional isVisible={false}>
          <button className={css.chartDownload} onClick={downloadImage}>
            <i className='fa fa-download'></i>
          </button>
        </Conditional>

        <div className={css.chartBody}>
          <Component chartRef={chartRef} {...props} />
        </div>
      </div>
    );
  };
}

export default withChart;
